import React from 'react';

export default function KakaoFail() {
    return <div className="text-4xl">결제 실패</div>;
}
